import Default from './default';

import Map from '../components/map';

class Location extends Default {
	namespace = 'location';

	beforeEnter = data => {
		super.beforeEnter(data);
		const scope = data.next.container;
		this.initMap(scope);
		console.log('location');
	};

	afterLeave = data => {
		super.afterLeave(data);
	};

	afterEnter = data => {
		super.afterEnter(data);
	};

	initMap = scope => {
		console.log('initMap()');
		const $map = $(scope).find('[data-map="el"]');

		console.log($map);

		if ($map.length) {
			console.log('init it dude');
			new Map($map);
			console.log('you did it');
		}
	};
}

export default new Location();
